import * as React from 'react';
import AppNavigation from './legacy/app/AppNavigation';
import { initDOMEvents, toggleDMPageLoader } from './legacy/utilities/DOM';
import { isDraft } from './legacy/utilities/ModuleHelper';
import { setDraft } from './legacy/utilities/FormEvent';
import { delay } from 'lodash';
import { AppWrapper } from 'AppWrapper';

interface IState {
	assetsLoaded: boolean;
}
interface IProps {}

class App extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);
		this.state = {
			assetsLoaded: false,
		};
	}

	componentDidMount() {
		const params = new URLSearchParams(document.location.search);
		const disableThreadLoader = params.get('DISABLE_THREAD_LOADER');

		// Setting the value of DISABLE_THREAD_LOADER in local storage
		// so our team can test this for a while before we enable it
		// for everyone else
		if (disableThreadLoader !== null) {
			localStorage.setItem(
				'DISABLE_THREAD_LOADER',
				disableThreadLoader === 'true' ? 'true' : 'false'
			);
		}

		this.setState({ assetsLoaded: true });

		window.onpopstate = (e) => {
			this.onPopStateChange(e);
		};
	}

	componentDidUpdate() {
		initDOMEvents();
	}

	onPopStateChange = (e: any) => {
		// Let's remove some loaders.
		toggleDMPageLoader({ destroy: true });

		if (isDraft()) {
			setDraft(false);
			if (!confirm('Leaving this screen will discard your changes.')) {
				history.go(1);

				// Let's remove some loaders.
				delay(() => toggleDMPageLoader({ destroy: true }), 70);
			}
		}
	};

	render() {
		if (this.state.assetsLoaded) {
			return (
				<AppWrapper>
					<AppNavigation />
				</AppWrapper>
			);
		} else {
			return <></>;
		}
	}
}

export default App;
